import { combineReducers, Reducer } from 'redux';
import { reducer as formReducer } from 'redux-form';

import { AppActionCreators } from 'actions/app';
import { initialState as invoiceInitialState } from 'helper/invoice';
import { AppState } from 'models/app';
import { accountReducer, initialState as accountInitialState } from 'reducers/account';
import { checkoutReducer, initialState as checkoutInitialState } from 'reducers/checkout';
import { flashMessageReducer, initialState as flashMessageInitialState } from 'reducers/flashMessage';
import { invoiceReducer } from 'reducers/invoice';
import { initialState as landingInitialState, landingReducer } from 'reducers/landing';
import { initialState as layoutInitialState, layoutReducer } from 'reducers/layout';
import { walletReducer } from 'reducers/wallet';
import { initialState as walletAccountInitialState } from 'reducers/wallet/account';
import { initialState as walletHistoryInitialState } from 'reducers/wallet/history';
import { initialState as walletRedeemInitialState } from 'reducers/wallet/redeem';
import { initialState as walletTopUpInitialState } from 'reducers/wallet/topUp';
import { initialState as walletTransactionInitialState } from 'reducers/wallet/transaction';
import { initialState as walletTransferInitialState } from 'reducers/wallet/transfer';

export const combinedReducers: Reducer<AppState> = combineReducers<AppState>({
  accountState: accountReducer,
  checkoutState: checkoutReducer,
  flashMessageState: flashMessageReducer,
  form: formReducer,
  invoiceState: invoiceReducer,
  landingState: landingReducer,
  layoutState: layoutReducer,
  walletState: walletReducer
});

export const initialState: AppState = {
  accountState: accountInitialState,
  checkoutState: checkoutInitialState,
  flashMessageState: flashMessageInitialState,
  invoiceState: invoiceInitialState,
  landingState: landingInitialState,
  layoutState: layoutInitialState,
  walletState: {
    accountState: walletAccountInitialState,
    historyState: walletHistoryInitialState,
    redeemState: walletRedeemInitialState,
    topUpState: walletTopUpInitialState,
    transactionState: walletTransactionInitialState,
    transferState: walletTransferInitialState
  }
};

type Action = typeof AppActionCreators[keyof typeof AppActionCreators];

export function appReducer(state = initialState, action: Action): typeof initialState {
  switch (action.type) {
    case AppActionCreators.resetAllState.type:
      return { ...initialState };
    default:
      return combinedReducers(state, action);
  }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/reducers/app.ts